var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('Master',{key:_vm.reRenderTabsPei,attrs:{"previous-path":_vm.previousPath},on:{"reRender":function($event){return _vm.reRender()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }